import { ChatIcon } from "../ui/icons/Icon";

// Avatar del chat (ChatAvatar.razor del portal actual): dos iniciales en mayúscula, ícono de persona si el nombre es un
// número, color estable por identidad y morado para los empleados IA. Contactos lo usa sin insignia de canal.

/** Primera letra de las dos primeras palabras (ChatText.Initials). */
export const initials = (name: string | null | undefined) =>
  (name ?? "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

/** Un número sin letras se muestra con el ícono de persona (ChatText.IsPhoneIdentity). */
export const isPhoneIdentity = (name: string | null | undefined) =>
  !!name?.trim() && /\d/.test(name) && !/\p{L}/u.test(name);

/** La clase del color del avatar (ChatText.AvatarToneClass). */
export const avatarToneClass = (id: number, external = false) =>
  `chat-avatar-tone-${Math.trunc((((id % 360) * 137 + (external ? 0 : 73)) % 360) / 30)}`;

export function ChatAvatar({
  name,
  identity,
  external = false,
  agent = false,
  className = "chat-row-avatar",
}: {
  name: string | null | undefined;
  identity: number;
  external?: boolean;
  agent?: boolean;
  className?: string;
}) {
  return (
    <span className={`${className} ${avatarToneClass(identity, external)}${agent ? " agent" : ""}`} aria-hidden="true">
      <span className="chat-avatar-content" aria-hidden="true">
        {isPhoneIdentity(name) ? <ChatIcon name="user" /> : initials(name)}
      </span>
    </span>
  );
}
